import React, { useContext } from "react"
import { MdSettings, MdClose } from "react-icons/md"
import { MobergButton, MobergTheme, MobergButtonVariant, MobergButtonShape, MobergIconSize, MobergColumn, MobergHeader, MobergFontSize, MobergDropdown, MobergCheckbox, MobergText } from "../../../../Moberg"
import { WINDOW_TIME_PRESETS } from "../../Viewport/Components/XAxis"
import { useMobergMenu } from "../../../../Hooks/useMobergMenu"
import { ConfigureWindowModalContext } from "./ConfigureWindowModal"
import { ModalityGraphGroupConfigJSON } from "../../../../Pages/Data/Visualize/DataReview/Types/ModalityGraphGroup"
import { MobergFontFamily } from '../../../../Components/MobergFont/MobergFont';
export const ConfigureWindowModalHeader: React.FC = () => {
    const { currentWindow, updateDisplayPageSize, updateWindowProps, closeModal } = useContext(ConfigureWindowModalContext)
	const valueCursor = (currentWindow?.props as ModalityGraphGroupConfigJSON | undefined)?.valueCursor === true
	const { open, MobergMenu } = useMobergMenu({ placement: "bottom-end" })

	return (
		<div style={{ display: "flex", alignItems: "center", justifyContent: "center", padding: "5px" }}>
			<div style={{ width: "40px" }} />

			<h3 style={{ flex: 1, margin: 0, fontFamily: MobergFontFamily.HEADER, fontSize: "20px", fontStyle: "normal", color: "var(--color-text-primary)", padding: "0 20px" }}> {"Configure Graphs"} </h3>

			<MobergButton theme={MobergTheme.BLACK} variant={MobergButtonVariant.CLEAR} shape={MobergButtonShape.SQUARE} onClick={open}>
				<MdSettings size={MobergIconSize.LARGE} />
			</MobergButton>

			<MobergButton theme={MobergTheme.BLACK} variant={MobergButtonVariant.CLEAR} shape={MobergButtonShape.SQUARE} onClick={closeModal}>
				<MdClose size={MobergIconSize.LARGE} />
			</MobergButton>

			<MobergMenu style={{ padding: "16px" }}>
				<MobergColumn gap="4px" horizontalAlign="center">
					<MobergHeader fontSize={MobergFontSize.LARGE}>Window Settings</MobergHeader>

					<div style={{ width: "100%", margin: "8px 0", borderTop: "1px solid var(--color-border-default)" }} />

					<MobergDropdown
                        label={"Initial Page Size"}
                        selectedValue={(currentWindow?.props as ModalityGraphGroupConfigJSON | undefined)?.viewDuration}
                        onChange={value => updateDisplayPageSize(parseInt(value))}
                        options={WINDOW_TIME_PRESETS
                            .filter(preset => preset.label !== "Page Size")
                            .map(preset => ({ label: preset.label, value: preset.time }))}
                    />

					<div style={{ width: "100%", margin: "8px 0", borderTop: "1px solid var(--color-border-default)" }} />

					{/* Click to pick a time: off unless turned on for this window. */}
					<div style={{ display: "flex", alignItems: "flex-start", gap: "8px", width: "100%", maxWidth: "280px" }} data-testid="window-settings-value-cursor">
						<MobergCheckbox isChecked={valueCursor} onChange={checked => updateWindowProps({ valueCursor: checked })} />
						<div style={{ display: "flex", flexDirection: "column", gap: "2px" }}>
							<MobergText fontWeight="bold">Click to pick a time</MobergText>
							<MobergText style={{ color: "var(--text-secondary-color)", fontSize: "13px" }}>
								Click a graph to mark a time. The numbers on the right show the values at that time, and the EEG on this display centers on it.
							</MobergText>
						</div>
					</div>
				</MobergColumn>
			</MobergMenu>
		</div>
	)
}
